import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    enabled: Boolean,
    resourceName: String,
    paramName: { type: String, default: "position" },
    animation: Number,
    handle: String,
    method: { type: String, default: "patch" }
  }

  connect() {
    this.sortableInstance = null
    // Don't auto-enable, wait for external control
    this.updateSortableState()
  }

  disconnect() {
    if (this.sortableInstance) {
      this.sortableInstance.destroy()
      this.sortableInstance = null
    }
  }

  enabledValueChanged() {
    this.updateSortableState()
  }

  updateSortableState() {
    if (this.enabledValue && !this.sortableInstance) {
      // Enable sortable
      this.sortableInstance = new Sortable(this.element, {
        animation: this.animationValue || 150,
        handle: this.handleValue || undefined,
        onUpdate: this.onUpdate.bind(this),
        onEnd: this.onEnd.bind(this)
      })
    } else if (!this.enabledValue && this.sortableInstance) {
      // Disable sortable
      this.sortableInstance.destroy()
      this.sortableInstance = null
    }
  }

  onUpdate({ item, newIndex }) {
    // Just update the visual order, don't save yet
    this.updateRankNumbers()
  }

  onEnd({ item, newIndex }) {
    // Called when drag ends - update rank numbers
    this.updateRankNumbers()
  }

  updateRankNumbers() {
    const items = this.element.querySelectorAll('li')
    items.forEach((item, index) => {
      const rankNumber = item.querySelector('.flex-shrink-0.w-8.h-8')
      if (rankNumber) {
        rankNumber.textContent = index + 1
      }
    })
  }

  // Public method to enable/disable from external JavaScript
  setEnabled(enabled) {
    this.enabledValue = enabled
  }
}
